const HREFS = {
  SIGN_IN: 'https://portal.zonifero.com/',
  LINKED_IN: 'https://www.linkedin.com/company/zonifero/',
  FACEBOOK: 'https://www.facebook.com/zonifero/',
  EXTRAHUT: 'https://www.extrahut.com/',
};

export default HREFS;



// WEBPACK FOOTER //
// ./src/common/consts/hrefs.js